/*
 * YAMIWARD — THE TWELVE BLOODLINES (血統登録)
 * Birth-month clan registry. The visitor declares a birth month; the Registry
 * (Ward Board backend) assigns the bloodline and issues a real, sequential
 * resident number per clan. Card is a 1080×1350 canvas — text/kanji/vector
 * only, so the canvas never taints. Standings show REAL counts from the
 * server, however small (board integrity rule: no inflated numbers).
 *
 * Only the birth month is ever collected — no full birthdates, no names.
 * If the board API is unreachable the card still issues with a deterministic
 * fallback number and no count claims.
 */
(function () {
    'use strict';

    var STORE_URL = 'yamiward.com';
    var BOARD_API = 'https://api.yamiward.com';
    var CLAN_KEY = 'yw_clan';
    var FIRST_WAVE_CUTOFF = 100; // per-clan founding cohort

    var MONTHS = ['JANUARY', 'FEBRUARY', 'MARCH', 'APRIL', 'MAY', 'JUNE',
        'JULY', 'AUGUST', 'SEPTEMBER', 'OCTOBER', 'NOVEMBER', 'DECEMBER'];

    var CLANS = [
        { key: 'yukionna', month: 1, name: 'YUKIONNA', kanji: '雪女', romaji: 'yuki-onna', color: '#DFE9F2',
          motto: 'The cold that keeps its word.', virtue: 'COMPOSURE', flaw: 'THAWS FOR NO ONE',
          omen: 'first frost on the shop windows' },
        { key: 'oni', month: 2, name: 'ONI', kanji: '鬼', romaji: 'oni', color: '#E51E25',
          motto: 'Forged loud. Thrown out every Setsubun. Comes back.', virtue: 'FORCE', flaw: 'SUBTLETY NOT FOUND',
          omen: 'scattered beans on the foundry floor' },
        { key: 'kitsune', month: 3, name: 'KITSUNE', kanji: '狐', romaji: 'kitsune', color: '#E8A33D',
          motto: 'Nine tails. Zero straight answers.', virtue: 'CUNNING', flaw: 'ALLERGIC TO THE TRUTH',
          omen: 'fox-rain falling through sunlight' },
        { key: 'kodama', month: 4, name: 'KODAMA', kanji: '木霊', romaji: 'kodama', color: '#9FD98A',
          motto: 'The echo that answers back.', virtue: 'PATIENCE', flaw: 'REPEATS EVERYTHING',
          omen: 'petals landing in perfect silence' },
        { key: 'kappa', month: 5, name: 'KAPPA', kanji: '河童', romaji: 'kappa', color: '#3AA79B',
          motto: 'River rules. Bow carefully.', virtue: 'DISCIPLINE', flaw: 'SPILLS EASILY',
          omen: 'a cucumber missing from the market stall' },
        { key: 'ameonna', month: 6, name: 'AMEONNA', kanji: '雨女', romaji: 'ame-onna', color: '#8A9BB8',
          motto: 'Brings the rain. Keeps the receipts.', virtue: 'MEMORY', flaw: 'NEVER FORGETS. EVER.',
          omen: 'rain that starts the moment you leave' },
        { key: 'hitodama', month: 7, name: 'HITODAMA', kanji: '人魂', romaji: 'hitodama', color: '#9BE8E0',
          motto: 'The soul-flame of Obon. Still burning.', virtue: 'DEVOTION', flaw: 'BURNS BOTH ENDS',
          omen: 'a lantern lit in an empty room' },
        { key: 'raiju', month: 8, name: 'RAIJU', kanji: '雷獣', romaji: 'raijū', color: '#A06AE8',
          motto: 'The thunder beast. Sleeps rarely, lands loudly.', virtue: 'VELOCITY', flaw: 'NO INDOOR VOICE',
          omen: 'static in the summer air' },
        { key: 'tsukiusagi', month: 9, name: 'TSUKIUSAGI', kanji: '月兎', romaji: 'tsuki-usagi', color: '#C9CDD6',
          motto: 'The moon rabbit. Pounding, forever.', virtue: 'CRAFT', flaw: 'PERFECTIONIST. UNTREATED.',
          omen: 'the harvest moon over Ward Zero' },
        { key: 'bakeneko', month: 10, name: 'BAKENEKO', kanji: '化け猫', romaji: 'bakeneko', color: '#E07B39',
          motto: 'The cat that noticed you first.', virtue: 'AWARENESS', flaw: 'KNOCKS THINGS OVER ON PURPOSE',
          omen: 'a second shadow at the crossing' },
        { key: 'tengu', month: 11, name: 'TENGU', kanji: '天狗', romaji: 'tengu', color: '#CF4A2F',
          motto: 'Mountain crow. Autumn wind. Zero humility.', virtue: 'MASTERY', flaw: 'HAS NEVER BEEN WRONG (ASK THEM)',
          omen: 'leaves spiraling upward, against the wind' },
        { key: 'ryu', month: 12, name: 'RYU', kanji: '龍', romaji: 'ryū', color: '#D8B45A',
          motto: 'The dragon that closes the year.', virtue: 'AUTHORITY', flaw: 'HOARDS. EVERYTHING.',
          omen: 'the first bell of the year’s last night' }
    ];

    // Shared registry data for other Ward systems (vault wallpapers etc.)
    window.YW_CLANS = { list: CLANS, months: MONTHS };

    function clanByMonth(m) { return CLANS[m - 1]; }
    function clanByKey(k) {
        for (var i = 0; i < CLANS.length; i++) if (CLANS[i].key === k) return CLANS[i];
        return null;
    }
    function rivalOf(clan) { return clanByMonth(((clan.month + 5) % 12) + 1); }

    var host = null;
    var standingsHost = null;
    var latestCounts = null;

    function el(tag, cls, text) {
        var node = document.createElement(tag);
        if (cls) node.className = cls;
        if (text !== undefined) node.textContent = text;
        return node;
    }

    // Identity is issued and signed by the Registry (see identity.js) — the browser
    // no longer invents one. Only used here for the offline card serial fallback.
    function getUid() {
        var id = window.YW_ID && YW_ID.get();
        return id ? id.uid : 'u-anon';
    }

    function savedClan() {
        try { return JSON.parse(localStorage.getItem(CLAN_KEY) || 'null'); } catch (e) { return null; }
    }

    // djb2 fallback number when the Registry is unreachable
    function hash(str) {
        var h = 5381;
        for (var i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) >>> 0;
        return h;
    }

    function registryNo(clan, seq) {
        var num = seq ? String(seq).padStart(5, '0') : String(hash(getUid() + clan.key) % 100000).padStart(5, '0');
        return 'YW-' + clan.name.slice(0, 4) + '-' + num;
    }

    // Bind the bloodline to the Ward list: the signup form's hidden tags input
    // carries the clan so Shopify tags the customer on subscribe.
    function syncSignupTags() {
        var saved = savedClan();
        if (!saved || !saved.key) return;
        var form = document.getElementById('signup-form');
        if (!form) return;
        var tags = form.querySelector('input[name="contact[tags]"]');
        if (tags && tags.value.indexOf('clan-') === -1) {
            tags.value = tags.value + ',bloodline,clan-' + saved.key;
        }
    }

    /* ---------- Registry API ---------- */

    function fetchCounts() {
        return fetch(BOARD_API + '/api/war/standings')
            .then(function (r) { return r.json(); })
            .then(function (data) { latestCounts = data; return data; })
            .catch(function () { return null; });
    }

    function register(month) {
        return YW_ID.post(BOARD_API + '/api/bloodline', { month: month }).then(function (r) {
            if (!r.ok) throw new Error('registry offline');
            return r.json();
        });
    }

    /* ---------- Screens ---------- */

    function showIntro() {
        host.innerHTML = '';
        var box = el('div', 'quiz-box bloodline-box');
        box.appendChild(el('div', 'quiz-kicker', 'RECORDS OFFICE — FORM 血-12 · BLOODLINE VERIFICATION'));
        box.appendChild(el('h3', 'quiz-heading', 'You were registered at birth.'));
        box.appendChild(el('p', 'quiz-sub', 'Twelve bloodlines keep the Ward — one for each month of the year. You do not choose yours. You were born into it. Declare your birth month and the Registry will confirm what your paperwork has said all along.'));

        var saved = savedClan();
        if (saved && saved.key) {
            var c = clanByKey(saved.key);
            if (c) {
                var prev = el('p', 'quiz-prev');
                prev.textContent = 'On record: ' + c.name + ' ' + c.kanji + ' bloodline, registry ' + registryNo(c, saved.seq) + '. Re-verification is permitted. Blood does not change; paperwork sometimes does.';
                box.appendChild(prev);
            }
        }

        var grid = el('div', 'bloodline-months');
        CLANS.forEach(function (c) {
            var b = el('button', 'bloodline-month-btn');
            b.type = 'button';
            b.style.setProperty('--clan-accent', c.color);
            b.appendChild(el('span', 'bloodline-month-label', MONTHS[c.month - 1].slice(0, 3)));
            b.appendChild(el('span', 'bloodline-month-kanji', c.kanji));
            b.appendChild(el('span', 'bloodline-month-name', c.name));
            b.addEventListener('click', function () { declare(c.month, b); });
            grid.appendChild(b);
        });
        box.appendChild(grid);
        box.appendChild(el('p', 'bloodline-privacy', 'The Registry records the month alone. No dates, no names — the Ward is nosy, not reckless.'));
        host.appendChild(box);
        renderStandings();
    }

    function declare(month, btn) {
        var old = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'FILING…';
        register(month).catch(function () { return register(month); }) // one silent retry
            .then(function (result) {
                btn.disabled = false; btn.textContent = old;
                finish(month, result.seq, result.counts);
            })
            .catch(function () {
                // Registry unreachable: say so. A fake "confirmed" card with no
                // server record used to strand players later (seal minting and
                // war points check the server, which had never heard of them).
                btn.disabled = false; btn.textContent = old;
                showRegistryDown();
            });
    }

    function showRegistryDown() {
        var boxEl = host.querySelector('.bloodline-box');
        if (!boxEl) return;
        var prev = boxEl.querySelector('.bloodline-offline');
        if (prev) prev.remove();
        var msg = el('p', 'bloodline-offline', 'The Registry is not answering. Nothing was filed — your paperwork is safe. Try again in a minute.');
        msg.style.cssText = 'color:#ff5b5b;border:1px solid rgba(255,91,91,.4);padding:10px 14px;margin-top:14px;font-family:"Space Mono",monospace;font-size:12px;letter-spacing:.06em;';
        boxEl.appendChild(msg);
    }

    function finish(month, seq, counts) {
        var clan = clanByMonth(month);
        try {
            localStorage.setItem(CLAN_KEY, JSON.stringify({ key: clan.key, month: month, seq: seq }));
        } catch (e) { /* ignore */ }
        latestCounts = null; // refetch war standings — registration just earned EN
        syncSignupTags();
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(function () { showResult(clan, seq, true); });
        } else {
            showResult(clan, seq, true);
        }
    }

    function showResult(clan, seq, scroll) {
        var rival = rivalOf(clan);
        host.innerHTML = '';
        var box = el('div', 'quiz-box quiz-result bloodline-box');
        box.style.setProperty('--quiz-accent', clan.color);

        box.appendChild(el('div', 'quiz-kicker', 'BLOODLINE CONFIRMED — ' + registryNo(clan, seq)));

        var nameRow = el('h3', 'quiz-result-name', clan.name + ' ');
        nameRow.appendChild(el('span', 'quiz-result-kanji', clan.kanji));
        box.appendChild(nameRow);
        box.appendChild(el('div', 'quiz-result-meta', 'THE ' + MONTHS[clan.month - 1] + ' BLOODLINE · ' + clan.romaji));
        box.appendChild(el('p', 'quiz-result-fragment', clan.motto));

        var note = el('p', 'quiz-result-note');
        note.appendChild(el('span', 'quiz-note-label', 'VIRTUE — '));
        note.appendChild(document.createTextNode(clan.virtue + '.  '));
        note.appendChild(el('span', 'quiz-note-label', 'FLAW — '));
        note.appendChild(document.createTextNode(clan.flaw + '.'));
        box.appendChild(note);

        var rivalNote = el('p', 'quiz-result-note bloodline-rival');
        rivalNote.appendChild(el('span', 'quiz-note-label', 'BLOOD RIVAL — '));
        rivalNote.appendChild(document.createTextNode(rival.name + ' ' + rival.kanji + ' (' + MONTHS[rival.month - 1] + '). The Registry recommends courtesy. It does not expect it.'));
        box.appendChild(rivalNote);

        if (seq) {
            var seqNote = el('p', 'bloodline-seq', 'You are resident No. ' + seq + ' of the ' + clan.name + ' bloodline' + (seq <= FIRST_WAVE_CUTOFF ? ' — FIRST WAVE. The founding cohort is permanent record.' : '.'));
            box.appendChild(seqNote);
        }

        var canvas = drawCard(clan, seq);
        var wrap = el('div', 'resident-card-wrap bloodline-card-wrap');
        canvas.className = 'resident-card-canvas bloodline-card-canvas';
        wrap.appendChild(canvas);
        box.appendChild(wrap);

        var actions = el('div', 'quiz-actions');

        var dl = el('button', 'btn btn-primary', 'DOWNLOAD BLOODLINE CARD');
        dl.addEventListener('click', function () {
            var a = document.createElement('a');
            a.download = 'yamiward-bloodline-' + clan.key + '.png';
            a.href = canvas.toDataURL('image/png');
            a.click();
        });
        actions.appendChild(dl);

        var share = el('button', 'btn btn-secondary', 'SHARE');
        share.addEventListener('click', function () {
            var url = 'https://' + STORE_URL + '/#bloodlines';
            var text = 'Born in ' + MONTHS[clan.month - 1].charAt(0) + MONTHS[clan.month - 1].slice(1).toLowerCase() + ' — the Yamiward Registry confirms I carry the ' + clan.name + ' ' + clan.kanji + ' bloodline. Which clan were you born into?';
            if (navigator.share) {
                navigator.share({ title: 'Yamiward — The Twelve Bloodlines', text: text, url: url }).catch(function () { /* cancelled */ });
            } else if (navigator.clipboard) {
                navigator.clipboard.writeText(text + ' ' + url).then(function () {
                    var o = share.textContent;
                    share.textContent = 'COPIED!';
                    setTimeout(function () { share.textContent = o; }, 1600);
                });
            }
        });
        actions.appendChild(share);

        var redo = el('button', 'btn btn-secondary', 'RE-VERIFY');
        redo.addEventListener('click', showIntro);
        actions.appendChild(redo);

        box.appendChild(actions);

        var bind = el('a', 'quiz-resident-link', 'Bind your bloodline to the Ward list — clan drops reach registered blood first →');
        bind.href = '#signup';
        box.appendChild(bind);

        var wall = el('a', 'quiz-resident-link', 'Claim your clan wallpaper in the Vault →');
        wall.href = '#vault';
        box.appendChild(wall);

        var capsule = el('div', 'bloodline-capsule');
        box.appendChild(capsule);
        loadCapsule(clan, capsule);

        host.appendChild(box);
        renderStandings();
        if (scroll) box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    /* ---------- Clan capsule (live products, nothing hardcoded) ---------- */

    // /products.json gives tags as an array; accept the comma-separated string too
    function hasTag(p, tag) {
        var tags = p.tags || [];
        if (typeof tags === 'string') tags = tags.split(',');
        for (var i = 0; i < tags.length; i++) {
            if (String(tags[i]).trim().toLowerCase() === tag) return true;
        }
        return false;
    }

    // A clan product carries clan-<clan>; until the catalogue tags are live the old title test still counts.
    function inClan(p, clan) {
        if (hasTag(p, 'clan-' + clan.key)) return true;
        // title fallback: remove after catalogue tags are live (plan Task 2.2 Step 5)
        return p.title.indexOf(clan.name + ' Bloodline') === 0;
    }

    // Japan Express is sold in the Japan market only (plan Task 2.5, decision D3): outside Japan (Shopify.country is
    // not JP, or not set) the capsule leaves it out. The rule is window.YW_JAPAN (assets/storefront.js), shared with
    // japan.js and shrine.js; without it (storefront.js failed to load) the capsule offers nothing: fail-closed.
    function sellsHere(p) {
        return !!(window.YW_JAPAN && window.YW_JAPAN.sellsHere(p));
    }

    // What a product is, for the capsule's kind label and order. The type-* tag decides, most specific first
    // (a crop hoodie carries type-hoodie too). type-accessory reads as its product type (a cap is CAP).
    var KIND_TAGS = [['type-crop-hoodie', 'CROP HOODIE'], ['type-tee', 'TEE'], ['type-hoodie', 'HOODIE'], ['type-tote', 'TOTE'], ['type-sticker', 'STICKER']];
    var KIND_ORDER = ['TEE', 'HOODIE', 'CROP HOODIE', 'TOTE', 'STICKER'];

    function kindOf(p) {
        for (var i = 0; i < KIND_TAGS.length; i++) {
            if (hasTag(p, KIND_TAGS[i][0])) return KIND_TAGS[i][1];
        }
        var type = String(p.product_type || '');
        if (hasTag(p, 'type-accessory')) return (type || 'ACCESSORY').toUpperCase();
        // title / product type fallback: remove after catalogue tags are live (plan Task 2.2 Step 5)
        var t = ' ' + p.title + ' ';
        if (/ crop hoodie\b/i.test(t)) return 'CROP HOODIE';
        if (/ hoodie\b/i.test(t) || /^hoodie$/i.test(type)) return 'HOODIE';
        if (/ tee\b/i.test(t) || /^t-shirt$/i.test(type)) return 'TEE';
        if (/ tote\b/i.test(t) || /^(tote|bags)$/i.test(type)) return 'TOTE';
        if (/ sticker\b/i.test(t) || /^(sticker|paper products)$/i.test(type)) return 'STICKER';
        return (type || 'ITEM').toUpperCase();
    }

    function loadCapsule(clan, hostEl) {
        fetch('/products.json?limit=250')
            .then(function (r) { return r.json(); })
            .then(function (data) {
                var items = (data.products || []).filter(function (p) { return inClan(p, clan) && sellsHere(p); });
                if (!items.length) return; // capsule not synced yet — stay hidden
                function rank(p) {
                    var i = KIND_ORDER.indexOf(kindOf(p));
                    return i < 0 ? KIND_ORDER.length : i;
                }
                items.sort(function (a, b) { return rank(a) - rank(b); });

                hostEl.appendChild(el('div', 'quiz-kicker bloodline-capsule-kicker',
                    'THE ' + clan.name + ' CAPSULE — YOUR CREST, YOUR MONTH'));
                var grid = el('div', 'bloodline-capsule-grid');

                items.forEach(function (p) {
                    var card = el('div', 'bloodline-capsule-card');
                    card.style.setProperty('--clan-accent', clan.color);

                    if (p.images && p.images[0]) {
                        var img = document.createElement('img');
                        img.src = p.images[0].src;
                        img.alt = p.title;
                        img.loading = 'lazy';
                        card.appendChild(img);
                    }
                    var kind = kindOf(p);
                    card.appendChild(el('div', 'bloodline-capsule-kind', kind));

                    var sel = document.createElement('select');
                    sel.className = 'bloodline-capsule-size';
                    (p.variants || []).forEach(function (v) {
                        if (v.available === false) return; // sold out: never offered
                        var o = document.createElement('option');
                        o.value = v.id;
                        o.textContent = v.title + ' — ' + YW_MONEY.format(v.price);
                        sel.appendChild(o);
                    });
                    card.appendChild(sel);

                    // Clan tees/hoodies are the same blanks as the main drop (B+C 3001 /
                    // Gildan 18500), so they share the storefront size guide. Stickers don't.
                    if (kind === 'TEE' || kind === 'HOODIE' || kind === 'CROP HOODIE') {
                        var guide = el('button', 'capsule-size-guide', 'Size guide');
                        guide.type = 'button';
                        guide.setAttribute('data-size-guide', kind === 'TEE' ? 'tee' : 'hoodie');
                        card.appendChild(guide);
                    }

                    var add = el('button', 'btn btn-primary bloodline-capsule-add', 'ADD TO BAG');
                    if (!sel.options.length) { sel.disabled = true; add.disabled = true; add.textContent = 'Sold out'; }
                    add.addEventListener('click', function () {
                        // assets/shell.js owns the cart: it adds, repaints the bag and opens the drawer
                        if (!window.YW_CART) { window.location.href = '/cart/add?id=' + encodeURIComponent(sel.value) + '&quantity=1'; return; }
                        add.disabled = true;
                        var settle = function (label) {
                            add.textContent = label;
                            setTimeout(function () { add.textContent = 'ADD TO BAG'; add.disabled = false; }, 1800);
                        };
                        window.YW_CART.add(Number(sel.value), 1).then(function () { settle('ADDED ✓'); }, function () { settle('TRY AGAIN'); });
                    });
                    card.appendChild(add);

                    grid.appendChild(card);
                });
                hostEl.appendChild(grid);
            })
            .catch(function () { /* capsule is progressive enhancement */ });
    }

    /* ---------- Standings (real counts only) ---------- */

    function renderStandings() {
        if (!standingsHost) return;
        var data = latestCounts;
        if (!data || !data.counts) {
            fetchCounts().then(function (d) { if (d) paintStandings(d); });
            return;
        }
        paintStandings(data);
    }

    function paintStandings(data) {
        standingsHost.innerHTML = '';
        var counts = data.counts || {};
        var en = data.en || {};
        var rows = CLANS.map(function (c) {
            return { clan: c, n: counts[c.key] || 0, en: en[c.key] || 0 };
        });
        rows.sort(function (a, b) { return b.en - a.en || b.n - a.n || a.clan.month - b.clan.month; });
        var total = rows.reduce(function (s, r) { return s + r.n; }, 0);
        var maxEn = rows[0].en || 1;

        var kicker = 'CLAN WAR — SEASON ' + (data.season || '') +
            (data.ends ? ' · ENDS ' + data.ends : '') +
            ' · ' + total + ' RESIDENT' + (total === 1 ? '' : 'S') + ' OF RECORD';
        standingsHost.appendChild(el('div', 'quiz-kicker bloodline-standings-kicker', kicker));

        if (data.leader) {
            var lead = clanByKey(data.leader);
            if (lead) {
                var banner = el('div', 'bloodline-war-leader');
                banner.style.setProperty('--clan-accent', lead.color);
                banner.textContent = lead.name + ' ' + lead.kanji + ' HOLDS THE WARD';
                standingsHost.appendChild(banner);
            }
        }

        var mine = savedClan();
        rows.forEach(function (r, i) {
            var row = el('div', 'bloodline-standing-row' + (mine && mine.key === r.clan.key ? ' mine' : ''));
            row.style.setProperty('--clan-accent', r.clan.color);
            row.appendChild(el('span', 'bloodline-standing-rank', String(i + 1).padStart(2, '0')));
            row.appendChild(el('span', 'bloodline-standing-kanji', r.clan.kanji));
            row.appendChild(el('span', 'bloodline-standing-name', r.clan.name));
            var barWrap = el('span', 'bloodline-standing-bar');
            var bar = el('span', 'bloodline-standing-fill');
            bar.style.width = Math.max(2, Math.round((r.en / maxEn) * 100)) + '%';
            barWrap.appendChild(bar);
            row.appendChild(barWrap);
            var score = el('span', 'bloodline-standing-count', r.en + ' 縁');
            score.title = r.n + ' resident' + (r.n === 1 ? '' : 's');
            row.appendChild(score);
            standingsHost.appendChild(row);
        });
        standingsHost.appendChild(el('p', 'bloodline-privacy',
            'EN 縁 flows to your clan through real acts only: every dollar spent on your bloodline (1 EN each), registering (+25), the Daily Summon (+2), and arcade honors (+5, thrice daily). The season\'s champion clan is recorded permanently. Scores are real — the Registry does not inflate.'));
    }

    /* ---------- Canvas card (1080×1350) ---------- */

    function roundRect(ctx, x, y, w, h, r) {
        ctx.beginPath();
        ctx.moveTo(x + r, y);
        ctx.arcTo(x + w, y, x + w, y + h, r);
        ctx.arcTo(x + w, y + h, x, y + h, r);
        ctx.arcTo(x, y + h, x, y, r);
        ctx.arcTo(x, y, x + w, y, r);
        ctx.closePath();
    }

    // Drawn seal crest: double ring, 12 month ticks (birth month lit), kanji core.
    function drawSeal(ctx, cx, cy, R, clan) {
        ctx.save();
        ctx.strokeStyle = clan.color;
        ctx.lineWidth = 6;
        ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2); ctx.stroke();
        ctx.lineWidth = 2;
        ctx.beginPath(); ctx.arc(cx, cy, R - 16, 0, Math.PI * 2); ctx.stroke();

        for (var i = 0; i < 12; i++) {
            var ang = (i / 12) * Math.PI * 2 - Math.PI / 2;
            var active = (i === clan.month - 1);
            var r1 = R + 12, r2 = R + (active ? 34 : 24);
            ctx.strokeStyle = active ? clan.color : 'rgba(243,243,245,0.28)';
            ctx.lineWidth = active ? 7 : 3;
            ctx.beginPath();
            ctx.moveTo(cx + Math.cos(ang) * r1, cy + Math.sin(ang) * r1);
            ctx.lineTo(cx + Math.cos(ang) * r2, cy + Math.sin(ang) * r2);
            ctx.stroke();
        }

        ctx.fillStyle = clan.color;
        ctx.font = '900 ' + Math.round(R * 0.82) + 'px "Noto Sans JP", sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        // multi-char kanji (木霊, 化け猫…) shrink to fit the ring
        while (ctx.measureText(clan.kanji).width > R * 1.5) {
            var size = parseInt(ctx.font, 10) - 8;
            if (size < 40) break;
            ctx.font = '900 ' + size + 'px "Noto Sans JP", sans-serif';
        }
        ctx.fillText(clan.kanji, cx, cy + R * 0.03);
        ctx.restore();
    }

    function drawCard(clan, seq) {
        var W = 1080, H = 1350;
        var rival = rivalOf(clan);
        var canvas = document.createElement('canvas');
        canvas.width = W; canvas.height = H;
        var ctx = canvas.getContext('2d');

        ctx.fillStyle = '#05050A';
        ctx.fillRect(0, 0, W, H);
        var grad = ctx.createRadialGradient(W / 2, 430, 60, W / 2, 430, 950);
        grad.addColorStop(0, clan.color + '22');
        grad.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, W, H);

        // Frame
        ctx.strokeStyle = clan.color;
        ctx.lineWidth = 6;
        roundRect(ctx, 40, 40, W - 80, H - 80, 8);
        ctx.stroke();
        ctx.strokeStyle = 'rgba(255,255,255,0.12)';
        ctx.lineWidth = 1;
        roundRect(ctx, 56, 56, W - 112, H - 112, 6);
        ctx.stroke();

        // Header
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        ctx.fillStyle = 'rgba(243,243,245,0.65)';
        ctx.font = '700 30px "Space Mono", monospace';
        ctx.fillText('YAMIWARD — RESIDENT REGISTRY', W / 2, 138);
        ctx.fillStyle = '#E51E25';
        ctx.font = '900 42px "Noto Sans JP", sans-serif';
        ctx.fillText('血 統 登 録', W / 2, 196);

        // Seal crest
        drawSeal(ctx, W / 2, 430, 150, clan);

        // Name block
        ctx.fillStyle = '#F3F3F5';
        ctx.font = '900 84px Outfit, sans-serif';
        while (ctx.measureText(clan.name).width > W - 220) {
            var s = parseInt(ctx.font, 10) - 6;
            if (s < 48) break;
            ctx.font = '900 ' + s + 'px Outfit, sans-serif';
        }
        ctx.fillText(clan.name, W / 2, 720);
        ctx.fillStyle = clan.color;
        ctx.font = '700 32px "Space Mono", monospace';
        ctx.fillText('THE ' + MONTHS[clan.month - 1] + ' BLOODLINE', W / 2, 772);

        // Motto
        ctx.fillStyle = 'rgba(243,243,245,0.88)';
        ctx.font = 'italic 400 36px Outfit, sans-serif';
        var motto = '“' + clan.motto + '”';
        if (ctx.measureText(motto).width > W - 220) ctx.font = 'italic 400 30px Outfit, sans-serif';
        ctx.fillText(motto, W / 2, 850);

        // Divider
        ctx.strokeStyle = 'rgba(255,255,255,0.15)';
        ctx.beginPath(); ctx.moveTo(200, 905); ctx.lineTo(W - 200, 905); ctx.stroke();

        // Virtue / flaw / rival
        ctx.fillStyle = 'rgba(243,243,245,0.7)';
        ctx.font = '400 27px "Space Mono", monospace';
        ctx.fillText('VIRTUE: ' + clan.virtue + '  ·  FLAW: ' + clan.flaw, W / 2, 965);
        ctx.fillText('BLOOD RIVAL: ' + rival.name + ' ' + rival.kanji + ' (' + MONTHS[rival.month - 1] + ')', W / 2, 1013);
        ctx.fillStyle = 'rgba(243,243,245,0.5)';
        ctx.font = 'italic 400 25px Outfit, sans-serif';
        ctx.fillText('Omen of the month: ' + clan.omen + '.', W / 2, 1061);

        // Registry line
        ctx.fillStyle = clan.color;
        ctx.font = '700 34px "Space Mono", monospace';
        ctx.fillText(registryNo(clan, seq) + (seq ? '  ·  RESIDENT No. ' + seq : ''), W / 2, 1130);

        // First-wave stamp
        if (seq && seq <= FIRST_WAVE_CUTOFF) {
            ctx.save();
            ctx.translate(W - 230, 1105);
            ctx.rotate(-0.1);
            ctx.strokeStyle = clan.color;
            ctx.fillStyle = clan.color;
            ctx.lineWidth = 3;
            ctx.font = '900 24px "Space Mono", monospace';
            ctx.textAlign = 'center';
            var st = 'FIRST WAVE';
            var tw = ctx.measureText(st).width;
            ctx.strokeRect(-tw / 2 - 14, -24, tw + 28, 40);
            ctx.fillText(st, 0, 4);
            ctx.restore();
        }

        // Footer
        ctx.textAlign = 'center';
        ctx.fillStyle = '#F3F3F5';
        ctx.font = '700 38px Outfit, sans-serif';
        ctx.fillText('WHICH CLAN WERE YOU BORN INTO?', W / 2, H - 160);
        ctx.fillStyle = clan.color;
        ctx.font = '700 28px "Space Mono", monospace';
        ctx.fillText(STORE_URL + '/#bloodlines', W / 2, H - 108);

        return canvas;
    }

    /* ---------- Init ---------- */

    function init() {
        host = document.getElementById('bloodline-stage');
        standingsHost = document.getElementById('bloodline-standings');
        syncSignupTags(); // returning residents carry their clan tag on subscribe
        if (!host) return;
        var saved = savedClan();
        var c = saved && clanByKey(saved.key);
        if (c) {
            if (document.fonts && document.fonts.ready) {
                document.fonts.ready.then(function () { showResult(c, saved.seq); });
            } else {
                showResult(c, saved.seq);
            }
        } else {
            showIntro();
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
